import { format } from 'shared/dateFns'

const GENERIC_PASTED_IMAGE_NAME = /^image\.(png|jpe?g)$/i
const IMAGE_EXTENSION = /\.(png|jpe?g)$/i

/**
 * Browsers name every pasted screenshot `image.png` (or `image.jpg`), and that
 * name is what the user's file library keeps, so a few pastes leave a few
 * indistinguishable files. Only that generic name is replaced; the clipboard
 * cannot tell a screenshot from a copied file, so a real file that happens to
 * be called `image.png` is renamed too. Screenshots that share a timestamp —
 * several in one paste, or separate pastes within the same second — are told
 * apart by a ` (2)`, ` (3)` suffix, skipping the names in `takenNames`.
 */
export const nameGenericPastedImages = (
  files: readonly File[],
  formatBaseName: (timestamp: string) => string,
  takenNames: readonly string[] = [],
  now: Date = new Date()
): File[] => {
  const baseName = formatBaseName(format(now, 'yyyy-MM-dd HH-mm-ss'))
  const usedStems = new Set(takenNames.map((name) => name.replace(IMAGE_EXTENSION, '')))

  return files.map((file) => {
    const match = GENERIC_PASTED_IMAGE_NAME.exec(file.name)
    if (match == null) return file

    let stem = baseName
    for (let copy = 2; usedStems.has(stem); copy += 1) {
      stem = `${baseName} (${copy})`
    }
    usedStems.add(stem)
    return new File([file], `${stem}.${match[1].toLowerCase()}`, {
      type: file.type,
      lastModified: file.lastModified
    })
  })
}
